import React, { Component } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { getMenuItems, getNavigationItems } from './app-navigation';
import { AuthPage, NotAuthPage, Splash } from './components';
import { SingleCard } from './components';
import { getScreenSize, subscribe, unsubscribe } from './utils/media-query';
import Footer from './components/footer/footer'
import { cognitoSignOut, isLoggedIn, getAuthenticatedCognitoUser } from './authentication/cognito';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Notification, Variant } from './components';
import { PageEvent } from './app-page-events';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNotification: false,
      notificationTitle: '',
      notificationMessage: '',
      notificationType: '',
      loading: true,
      loggedIn: false,
      screenSizeClass: this.getScreenSizeClass(),
      navigationItems: [],
      userMenuItems: [],
      userId: null,
      userFullName: '',
      showPopupText: false
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.authPageRef = React.createRef();
  }

  async componentDidMount() {
    await this.loadNavigationPages();
    subscribe(this.screenSizeChanged);
    
    if (window.location.href.endsWith('logout'))
      window.location.href = '/';
  }

  loadNavigationPages = async () => {
    const cognitoUser = await getAuthenticatedCognitoUser();
    
    const userMenuItems = getMenuItems(this.menuItemClicked); // Pass the 'menuItemClicked()' function

    this.setState({
      loading: false,
      loggedIn: isLoggedIn(),
      navigationItems: getNavigationItems(),
      userMenuItems: userMenuItems,
      userId: cognitoUser ? cognitoUser.signInUserSession.idToken.payload.sub : undefined,
      userFullName: cognitoUser ? cognitoUser.signInUserSession.idToken.payload.given_name : '',
    });
  }

  componentWillUnmount() {
    unsubscribe(this.screenSizeChanged);
    unsubscribe(this.pageUpdateEvent);
  }

  pageUpdateEvent = (event, args) => {
    if (event === PageEvent.SETTINGS_MODULE_UPDATED) {
      this.loadNavigationPages();
    } else if (event === PageEvent.APP_LOGOUT) {
      this.setState({ loggedIn: false });
    } else if (event === PageEvent.PROFILE_ACCOUNT_DELETED || event === PageEvent.PROFILE_PASSWORD_UPDATED) {
      cognitoSignOut();
      this.setState({ loggedIn: false });
    }
  }

  handleClose = () => {
    this.setState({
      showPopupText: false
    })
  }

  handleShow = () => {
    this.setState({
      showPopupText: true
    })
  }

  render() {
    const { navigationItems, userMenuItems, userFullName, userId, loading, loggedIn,
      notificationTitle, notificationMessage, notificationType, showNotification } = this.state;

    return (
      <div>
        <Notification
          delay={notificationType === Variant.DANGER && 10000}
          show={showNotification}
          title={notificationTitle}
          message={notificationMessage}
          type={notificationType}
          onClose={this.onNotifyClose}
        />

        {loading && (
          // Show splash screen
          <Router>
            <SingleCard>
              <Splash />
            </SingleCard>
          </Router>
        )}

        {!loading && loggedIn && (
          // User authenticated: show home page
          <AuthPage
            navigationItems={navigationItems}
            userMenuItems={userMenuItems}
            userId={userId}
            userFullName={userFullName}
            pageUpdateEvent={(e) => this.pageUpdateEvent(e)}
            onNotifyEvent={(e) => this.onNotifyEvent(e)}
            ref={this.authPageRef}
          />
        )}

        {!loading && !loggedIn && (
          // User not authenticated: show login page
          <Router>
            <Container>
              <Row className='justify-content-md-center'>
                <Col md='auto'>
                  <Card className='app-card'>
                    <Card.Body>
                      <NotAuthPage
                        onLoginClicked={this.onLoginClicked}
                        onNotifyEvent={(e) => this.onNotifyEvent(e)}
                      />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </Router>
        )}
        <Footer />
      </div>
    );
  }

  getScreenSizeClass() {
    const screenSizes = getScreenSize();
    return Object.keys(screenSizes).filter(cl => screenSizes[cl]).join(' ');
  }

  screenSizeChanged = () => {
    this.setState({
      screenSizeClass: this.getScreenSizeClass()
    });
  }

  menuItemClicked = (args) => {
    if (!args || !args.text)
      return;

    if (args.text === 'Logout') {
      cognitoSignOut();
      this.setState({ loggedIn: false });
    } else {
      window.location.href = `/#${args.path}`;
    }
  };

  onLoginClicked = async () => {
    this.loadNavigationPages();
  };

  onNotifyEvent = (e) => {
    this.setState({
      showNotification: true,
      notificationTitle: e.notificationTitle,
      notificationMessage: e.notificationMessage,
      notificationType: e.notificationType,
    });
  };

  onNotifyClose = (e) => {
    this.setState({
      showNotification: false
    })
  };
}

export default App;